// import React, { useState, useEffect, useRef } from 'react';
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Typography,
//   Chip,
//   IconButton,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Alert,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import { Add, Edit, Delete, LocationOn, ContentPaste, Clear } from '@mui/icons-material';
// import { Formik, Form } from 'formik';
// import * as Yup from 'yup';
// import { GoogleMap } from '@react-google-maps/api';
// import apiService from '../services/apiService';
// import { loadGoogleMaps } from '../utils/loadGoogleMaps';

// const mapContainerStyle = {
//   width: '100%',
//   height: '400px',
// };

// const defaultCenter = {
//   lat: 12.9716,
//   lng: 77.5946,
// };

// const RegionsPage = () => {
//   const [regions, setRegions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [openDialog, setOpenDialog] = useState(false);
//   const [editMode, setEditMode] = useState(false);
//   const [selectedRegion, setSelectedRegion] = useState(null);
//   const [polygonPath, setPolygonPath] = useState([]);
//   const [drawingManager, setDrawingManager] = useState(null);
//   const [mapInstance, setMapInstance] = useState(null);
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [loadError, setLoadError] = useState(null);
//   const [jsonInput, setJsonInput] = useState('');
//   const [jsonError, setJsonError] = useState('');
//   const [showJsonPaste, setShowJsonPaste] = useState(false);
//   const nativePolygonRef = useRef(null);

//   useEffect(() => {
//     fetchRegions();
//   }, []);

//   useEffect(() => {
//     // Load Google Maps dynamically
//     loadGoogleMaps()
//       .then(() => {
//         console.log('Google Maps API loaded successfully');
//         console.log('window.google.maps.drawing available:', !!window.google?.maps?.drawing);
//         setIsLoaded(true);
//       })
//       .catch((error) => {
//         console.error('Error loading Google Maps:', error);
//         setLoadError(error);
//       });
//   }, []);

//   // Fit map bounds to polygon when editing or when JSON is pasted
//   useEffect(() => {
//     if (mapInstance && polygonPath.length > 0 && openDialog) {
//       const bounds = new window.google.maps.LatLngBounds();
//       polygonPath.forEach(point => {
//         bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
//       });
//       mapInstance.fitBounds(bounds);
//     }
//   }, [mapInstance, polygonPath, openDialog]);

//   // Draw/update native Google Maps polygon when polygonPath changes
//   useEffect(() => {
//     // Remove previous polygon
//     if (nativePolygonRef.current) {
//       nativePolygonRef.current.setMap(null);
//       nativePolygonRef.current = null;
//     }

//     // Draw new polygon if we have a map and path
//     if (mapInstance && polygonPath.length > 0 && window.google) {
//       const polygon = new window.google.maps.Polygon({
//         paths: polygonPath.map(p => ({ lat: p.lat, lng: p.lng })),
//         fillColor: '#FFC107',
//         fillOpacity: 0.3,
//         strokeWeight: 2,
//         strokeColor: '#FFC107',
//         clickable: false,
//       });
//       polygon.setMap(mapInstance);
//       nativePolygonRef.current = polygon;
//     }
//   }, [mapInstance, polygonPath]);

//   const fetchRegions = async () => {
//     try {
//       setLoading(true);
//       const response = await apiService.getRegions();

//       if (response.success) {
//         setRegions(response.data);
//         setError('');
//       } else {
//         setError(response.message || 'Failed to load regions');
//         setRegions([]);
//       }
//     } catch (err) {
//       console.error('Regions error:', err);
//       setError('Failed to load regions. Please check your connection and try again.');
//       setRegions([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAdd = () => {
//     setEditMode(false);
//     setSelectedRegion(null);
//     setPolygonPath([]);
//     setJsonInput('');
//     setJsonError('');
//     setShowJsonPaste(false);
//     if (drawingManager) {
//       drawingManager.setMap(null);
//     }
//     setDrawingManager(null);
//     setMapInstance(null);
//     setOpenDialog(true);
//   };


//   // Parse pasted JSON and apply region coordinates + name to the form
//   const handleJsonPaste = (setFieldValue) => {
//     setJsonError('');

//     if (!jsonInput.trim()) {
//       setJsonError('Please paste the region JSON data');
//       return;
//     }

//     try {
//       let parsed = JSON.parse(jsonInput.trim());

//       // Support both array format and single object format
//       // Array format: [{ name, coordinates, area_sqm }]
//       // Single object: { name, coordinates, area_sqm }
//       if (Array.isArray(parsed)) {
//         if (parsed.length === 0) {
//           setJsonError('JSON array is empty. Please paste valid region data.');
//           return;
//         }
//         parsed = parsed[0]; // Take the first region
//       }

//       // Extract coordinates
//       const coordinates = parsed.coordinates || parsed.boundary_polygon;
//       if (!coordinates || !Array.isArray(coordinates) || coordinates.length < 3) {
//         setJsonError('Invalid JSON: must contain "coordinates" array with at least 3 points. Expected format: [{ "lat": 12.97, "lng": 77.59 }, ...]');
//         return;
//       }

//       // Validate each coordinate has lat and lng
//       for (let i = 0; i < coordinates.length; i++) {
//         const point = coordinates[i];
//         if (typeof point.lat !== 'number' || typeof point.lng !== 'number') {
//           setJsonError(`Invalid coordinate at index ${i}: each point must have numeric "lat" and "lng" fields`);
//           return;
//         }
//       }

//       // Apply polygon path
//       const path = coordinates.map(p => ({ lat: p.lat, lng: p.lng }));
//       setPolygonPath(path);

//       // Auto-fill region name if present and form name is empty
//       if (parsed.name && setFieldValue) {
//         setFieldValue('name', parsed.name);
//       }

//       // Fit map to the new polygon bounds
//       if (mapInstance) {
//         const bounds = new window.google.maps.LatLngBounds();
//         path.forEach(point => {
//           bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
//         });
//         mapInstance.fitBounds(bounds);
//       }

//       // Clear JSON input and hide the paste area
//       setJsonInput('');
//       setJsonError('');
//       setShowJsonPaste(false);
//     } catch (e) {
//       setJsonError(`Invalid JSON format: ${e.message}`);
//     }
//   };

//   const handleEdit = (region) => {
//     setEditMode(true);
//     setSelectedRegion(region);
//     setJsonInput('');
//     setJsonError('');
//     setShowJsonPaste(false);
//     if (drawingManager) {
//       drawingManager.setMap(null);
//     }
//     setDrawingManager(null);
//     setMapInstance(null);

//     // Parse boundary polygon if exists
//     if (region.boundary_polygon) {
//       try {
//         const parsedPath = JSON.parse(region.boundary_polygon);
//         setPolygonPath(parsedPath);
//       } catch (e) {
//         console.error('Error parsing polygon:', e);
//         setPolygonPath([]);
//       }
//     } else {
//       setPolygonPath([]);
//     }

//     setOpenDialog(true);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm('Are you sure you want to delete this region?')) {
//       return;
//     }

//     try {
//       const response = await apiService.deleteRegion(id);

//       if (response.success) {
//         alert('Region deleted successfully');
//         fetchRegions();
//       } else {
//         alert(response.message || 'Failed to delete region');
//       }
//     } catch (err) {
//       alert('Failed to delete region');
//     }
//   };


//   const handleSubmit = async (values, { setSubmitting }) => {
//     try {
//       // Validate that boundary polygon is drawn
//       if (polygonPath.length === 0) {
//         alert('Please draw a region boundary on the map. This is required.');
//         setSubmitting(false);
//         return;
//       }

//       // Add boundary polygon
//       const submitData = {
//         ...values,
//         boundary_polygon: JSON.stringify(polygonPath),
//       };

//       let response;
//       if (editMode) {
//         response = await apiService.updateRegion(selectedRegion.id, submitData);
//       } else {
//         response = await apiService.addRegion(submitData);
//       }

//       if (response.success) {
//         alert(`Region ${editMode ? 'updated' : 'created'} successfully`);
//         setOpenDialog(false);
//         setPolygonPath([]);
//         fetchRegions();
//       } else {
//         alert(response.message || 'Operation failed');
//       }
//     } catch (err) {
//       console.error('Submit error:', err);
//       alert('Operation failed');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const validationSchema = Yup.object({
//     name: Yup.string().required('Region name is required'),
//     state: Yup.string().required('State is required'),
//     country: Yup.string().required('Country is required'),
//     distance_unit: Yup.string().required('Distance unit is required'),
//     status: Yup.string().required('Status is required'),
//   });

//   const columns = [
//     {
//       field: 'name',
//       headerName: 'Region Name',
//       width: 200,
//       renderCell: (params) => (
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//           <LocationOn color="primary" />
//           <Typography variant="body2" fontWeight={600}>
//             {params.row.name}
//           </Typography>
//         </Box>
//       ),
//     },
//     {
//       field: 'state',
//       headerName: 'State',
//       width: 150,
//     },
//     {
//       field: 'country',
//       headerName: 'Country',
//       width: 120,
//     },
//     {
//       field: 'distance_unit',
//       headerName: 'Distance Unit',
//       width: 130,
//     },
//     {
//       field: 'status',
//       headerName: 'Status',
//       width: 130,
//       renderCell: (params) =>
//         params.row.status === 'active' ? (
//           <Chip label="Active" color="success" size="small" />
//         ) : (
//           <Chip label="Inactive" color="default" size="small" />
//         ),
//     },
//     {
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       sortable: false,
//       renderCell: (params) => (
//         <Box>
//           <IconButton size="small" onClick={() => handleEdit(params.row)}>
//             <Edit fontSize="small" />
//           </IconButton>
//           <IconButton size="small" color="error" onClick={() => handleDelete(params.row.id)}>
//             <Delete fontSize="small" />
//           </IconButton>
//         </Box>
//       ),
//     },
//   ];

//   return (
//     <Box>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//         <Box>
//           <Typography variant="h4" fontWeight="bold" gutterBottom>
//             Regions
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             Manage service regions with geographic boundaries
//           </Typography>
//         </Box>
//         <Button variant="contained" startIcon={<Add />} onClick={handleAdd}>
//           Add Region
//         </Button>
//       </Box>

//       {error && (
//         <Alert severity="error" sx={{ mb: 3 }}>
//           {error}
//         </Alert>
//       )}

//       <Card>
//         <CardContent>
//           <DataGrid
//             rows={regions}
//             columns={columns}
//             pageSize={10}
//             rowsPerPageOptions={[10, 25, 50]}
//             disableSelectionOnClick
//             autoHeight
//             loading={loading}
//             sx={{
//               '& .MuiDataGrid-cell:focus': {
//                 outline: 'none',
//               },
//             }}
//           />
//         </CardContent>
//       </Card>

//       {/* Add/Edit Region Dialog */}
//       <Dialog
//         open={openDialog}
//         onClose={() => {
//           if (drawingManager) {
//             drawingManager.setMap(null);
//           }
//           if (nativePolygonRef.current) {
//             nativePolygonRef.current.setMap(null);
//             nativePolygonRef.current = null;
//           }
//           setOpenDialog(false);
//           setDrawingManager(null);
//           setMapInstance(null);
//         }}
//         maxWidth="md"
//         fullWidth
//       >
//         <DialogTitle>{editMode ? 'Edit' : 'Add'} Region</DialogTitle>
//         <Formik
//           initialValues={{
//             name: selectedRegion?.name || '',
//             state: selectedRegion?.state || '',
//             country: selectedRegion?.country || 'India',
//             distance_unit: selectedRegion?.distance_unit || 'km',
//             status: selectedRegion?.status || 'active',
//             description: selectedRegion?.description || '',
//           }}
//           validationSchema={validationSchema}
//           onSubmit={handleSubmit}
//           enableReinitialize
//         >
//           {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
//             <Form>
//               <DialogContent>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       name="name"
//                       label="Region Name"
//                       value={values.name}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.name && Boolean(errors.name)}
//                       helperText={touched.name && errors.name}
//                       placeholder="e.g., Bangalore Central"
//                     />
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       name="state"
//                       label="State"
//                       value={values.state}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.state && Boolean(errors.state)}
//                       helperText={touched.state && errors.state}
//                       placeholder="e.g., Karnataka"
//                     />
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <TextField
//                       fullWidth
//                       name="country"
//                       label="Country"
//                       value={values.country}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       error={touched.country && Boolean(errors.country)}
//                       helperText={touched.country && errors.country}
//                       placeholder="e.g., India"
//                     />
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <FormControl fullWidth>
//                       <InputLabel>Distance Unit</InputLabel>
//                       <Select
//                         name="distance_unit"
//                         value={values.distance_unit}
//                         onChange={handleChange}
//                         label="Distance Unit"
//                         error={touched.distance_unit && Boolean(errors.distance_unit)}
//                       >
//                         <MenuItem value="km">Kilometer (km)</MenuItem>
//                         <MenuItem value="mile">Mile</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12} md={6}>
//                     <FormControl fullWidth>
//                       <InputLabel>Status</InputLabel>
//                       <Select
//                         name="status"
//                         value={values.status}
//                         onChange={handleChange}
//                         label="Status"
//                       >
//                         <MenuItem value="active">Active</MenuItem>
//                         <MenuItem value="inactive">Inactive</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       name="description"
//                       label="Description"
//                       multiline
//                       rows={2}
//                       value={values.description}
//                       onChange={handleChange}
//                       onBlur={handleBlur}
//                       placeholder="Optional description of the region"
//                     />
//                   </Grid>

//                   <Grid item xs={12}>
//                     <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                       <Typography variant="subtitle2">
//                         Region Boundary <span style={{ color: 'red' }}>*</span>
//                       </Typography>
//                       <Button
//                         size="small"
//                         variant={showJsonPaste ? 'contained' : 'outlined'}
//                         startIcon={<ContentPaste />}
//                         onClick={() => {
//                           setShowJsonPaste(!showJsonPaste);
//                           setJsonError('');
//                         }}
//                       >
//                         {showJsonPaste ? 'Hide JSON Paste' : 'Paste Region JSON'}
//                       </Button>
//                     </Box>

//                     {/* JSON Paste Section */}
//                     {showJsonPaste && (
//                       <Box sx={{ mb: 2, p: 2, border: '1px solid #1976d2', borderRadius: 1, bgcolor: '#f5f9ff' }}>
//                         <Typography variant="body2" fontWeight={600} gutterBottom>
//                           Paste Client's Region JSON Data
//                         </Typography>
//                         <Typography variant="caption" color="text.secondary" component="div" sx={{ mb: 1.5 }}>
//                           Paste the JSON from the client's region drawing tool. Supports formats like:<br/>
//                           <code>{`[{ "name": "Region 1", "coordinates": [{ "lat": 12.97, "lng": 77.59 }, ...] }]`}</code>
//                         </Typography>
//                         <TextField
//                           fullWidth
//                           multiline
//                           rows={5}
//                           value={jsonInput}
//                           onChange={(e) => {
//                             setJsonInput(e.target.value);
//                             setJsonError('');
//                           }}
//                           placeholder={`Paste region JSON here, e.g.:\n[\n  {\n    "name": "Region 1",\n    "coordinates": [\n      { "lat": 12.769092, "lng": 80.222975 },\n      { "lat": 12.868957, "lng": 80.105482 }\n    ]\n  }\n]`}
//                           sx={{ mb: 1.5, bgcolor: 'white', fontFamily: 'monospace', fontSize: '0.85rem' }}
//                           InputProps={{ style: { fontFamily: 'monospace', fontSize: '0.85rem' } }}
//                         />
//                         {jsonError && (
//                           <Alert severity="error" sx={{ mb: 1.5 }}>
//                             {jsonError}
//                           </Alert>
//                         )}
//                         <Box sx={{ display: 'flex', gap: 1 }}>
//                           <Button
//                             variant="contained"
//                             size="small"
//                             startIcon={<ContentPaste />}
//                             onClick={() => handleJsonPaste(setFieldValue)}
//                           >
//                             Apply Region Data
//                           </Button>
//                           <Button
//                             variant="outlined"
//                             size="small"
//                             startIcon={<Clear />}
//                             onClick={() => {
//                               setJsonInput('');
//                               setJsonError('');
//                             }}
//                           >
//                             Clear
//                           </Button>
//                         </Box>
//                       </Box>
//                     )}

//                     <Alert severity="info" sx={{ mb: 2 }}>
//                       <Typography variant="body2" gutterBottom>
//                         <strong>How to set region boundary:</strong>
//                       </Typography>
//                       <Typography variant="caption" component="div">
//                         <strong>Option 1 - Paste JSON:</strong> Click "Paste Region JSON" above and paste client's region data<br/>
//                         <strong>Option 2 - Draw manually:</strong> Use the drawing tools at the top center of the map, click the polygon tool, click points on the map, then click the first point to close
//                       </Typography>
//                     </Alert>

//                     {loadError && (
//                       <Alert severity="error" sx={{ mb: 1 }}>
//                         Error loading Google Maps. Please check your API key and internet connection.
//                       </Alert>
//                     )}

//                     {!isLoaded && !loadError && (
//                       <Alert severity="warning" sx={{ mb: 1 }}>
//                         Loading Google Maps...
//                       </Alert>
//                     )}

//                     {isLoaded && drawingManager && (
//                       <Alert severity="success" sx={{ mb: 1 }}>
//                         ✓ Map ready! Use the drawing tools at the top center of the map to draw the region boundary.
//                       </Alert>
//                     )}

//                     {isLoaded && (
//                       <Box
//                         sx={{
//                           border: '1px solid #ddd',
//                           borderRadius: 1,
//                           overflow: 'hidden',
//                           position: 'relative'
//                         }}
//                       >
//                         <GoogleMap
//                           key={openDialog ? 'map-open' : 'map-closed'}
//                           mapContainerStyle={mapContainerStyle}
//                           center={defaultCenter}
//                           zoom={12}
//                           onLoad={(map) => {
//                             console.log('Map loaded successfully');
//                             console.log('Google Maps Drawing available:', !!window.google?.maps?.drawing);

//                             // Store map instance
//                             setMapInstance(map);

//                             // Manually create DrawingManager to ensure controls appear
//                             if (window.google && window.google.maps && window.google.maps.drawing) {
//                               const dm = new window.google.maps.drawing.DrawingManager({
//                                 drawingMode: null,
//                                 drawingControl: true,
//                                 drawingControlOptions: {
//                                   position: window.google.maps.ControlPosition.TOP_CENTER,
//                                   drawingModes: [window.google.maps.drawing.OverlayType.POLYGON],
//                                 },
//                                 polygonOptions: {
//                                   fillColor: '#FFC107',
//                                   fillOpacity: 0.3,
//                                   strokeWeight: 2,
//                                   strokeColor: '#FFC107',
//                                   clickable: true,
//                                   editable: true,
//                                   draggable: false,
//                                 },
//                               });

//                               dm.setMap(map);
//                               setDrawingManager(dm);

//                               window.google.maps.event.addListener(dm, 'polygoncomplete', (polygon) => {
//                                 const path = polygon.getPath();
//                                 const coordinates = [];
//                                 for (let i = 0; i < path.getLength(); i++) {
//                                   const point = path.getAt(i);
//                                   coordinates.push({
//                                     lat: point.lat(),
//                                     lng: point.lng(),
//                                   });
//                                 }
//                                 setPolygonPath(coordinates);
//                                 polygon.setMap(null);
//                               });

//                               console.log('✅ DrawingManager manually initialized with controls');
//                             }
//                           }}
//                         >
//                         </GoogleMap>
//                       </Box>
//                     )}

//                     {polygonPath.length > 0 && (
//                       <Box mt={1}>
//                         <Chip
//                           label={`Boundary drawn (${polygonPath.length} points)`}
//                           color="success"
//                           size="small"
//                           onDelete={() => {
//                               setPolygonPath([]);
//                               }}
//                         />
//                       </Box>
//                     )}
//                   </Grid>
//                 </Grid>
//               </DialogContent>
//               <DialogActions>
//                 <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
//                 <Button type="submit" variant="contained" disabled={isSubmitting}>
//                   {editMode ? 'Update' : 'Create'}
//                 </Button>
//               </DialogActions>
//             </Form>
//           )}
//         </Formik>
//       </Dialog>
//     </Box>
//   );
// };

// export default RegionsPage;


import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Chip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Add, Edit, Delete, LocationOn, ContentPaste, Clear } from '@mui/icons-material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { GoogleMap, useLoadScript } from '@react-google-maps/api';
import apiService from '../services/apiService';

const mapContainerStyle = {
  width: '100%',
  height: '400px',
};

const defaultCenter = {
  lat: 12.9716,
  lng: 77.5946,
};

const libraries = ['geometry', 'drawing'];

const RegionsPage = () => {
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [polygonPath, setPolygonPath] = useState([]);
  const [mapInstance, setMapInstance] = useState(null);
  const [jsonInput, setJsonInput] = useState('');
  const [jsonError, setJsonError] = useState('');
  const [showJsonPaste, setShowJsonPaste] = useState(false);
  const [isDrawing, setIsDrawing] = useState(false);
  const [initialZoomSet, setInitialZoomSet] = useState(false);
  const polygonRef = useRef(null);
  const pathChangeListenerRef = useRef(null);
  const mapCenterRef = useRef(null);
  const mapZoomRef = useRef(null);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  useEffect(() => {
    fetchRegions();
  }, []);

  // Fit map bounds to polygon when editing or when JSON is pasted
  useEffect(() => {
    if (mapInstance && polygonPath.length > 0 && openDialog && !initialZoomSet) {
      try {
        const bounds = new window.google.maps.LatLngBounds();
        let validPoints = 0;
        polygonPath.forEach(point => {
          if (point && typeof point.lat === 'number' && typeof point.lng === 'number') {
            bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
            validPoints++;
          }
        });
        
        if (validPoints > 2) {
          // Add a small padding to the bounds
          mapInstance.fitBounds(bounds, 50);
          setInitialZoomSet(true);
        }
      } catch (error) {
        console.error('Error fitting bounds:', error);
      }
    }
  }, [mapInstance, polygonPath, openDialog, initialZoomSet]);

  // Reset initialZoomSet when dialog closes
  useEffect(() => {
    if (!openDialog) {
      setInitialZoomSet(false);
    }
  }, [openDialog]);

  // Draw/update native Google Maps polygon when polygonPath changes
  useEffect(() => {
    if (!mapInstance || !window.google) return;

    // Remove previous polygon and listener
    if (polygonRef.current) {
      if (pathChangeListenerRef.current) {
        window.google.maps.event.removeListener(pathChangeListenerRef.current);
        pathChangeListenerRef.current = null;
      }
      polygonRef.current.setMap(null);
      polygonRef.current = null;
    }

    // Draw new polygon if we have a path
    if (polygonPath.length > 2) {
      try {
        const polygon = new window.google.maps.Polygon({
          paths: polygonPath.map(p => ({ lat: p.lat, lng: p.lng })),
          fillColor: '#FFC107',
          fillOpacity: 0.3,
          strokeWeight: 2,
          strokeColor: '#FFC107',
          editable: true,
          draggable: false,
          clickable: false,
        });
        
        polygon.setMap(mapInstance);
        polygonRef.current = polygon;

        // Listen for edits to the polygon
        pathChangeListenerRef.current = window.google.maps.event.addListener(
          polygon, 
          'paths_changed', 
          () => {
            try {
              const path = polygon.getPath();
              const coordinates = [];
              for (let i = 0; i < path.getLength(); i++) {
                const point = path.getAt(i);
                coordinates.push({
                  lat: point.lat(),
                  lng: point.lng(),
                });
              }
              // Only update if the coordinates have actually changed
              const currentPathString = JSON.stringify(coordinates);
              const oldPathString = JSON.stringify(polygonPath);
              if (currentPathString !== oldPathString && coordinates.length > 2) {
                console.log('Polygon edited, updating path');
                setPolygonPath(coordinates);
              }
            } catch (error) {
              console.error('Error updating polygon path:', error);
            }
          }
        );

        // Also listen for mouseup to capture final changes
        window.google.maps.event.addListener(polygon, 'mouseup', () => {
          try {
            const path = polygon.getPath();
            const coordinates = [];
            for (let i = 0; i < path.getLength(); i++) {
              const point = path.getAt(i);
              coordinates.push({
                lat: point.lat(),
                lng: point.lng(),
              });
            }
            if (coordinates.length > 2) {
              console.log('Mouse up on polygon, updating path');
              setPolygonPath(coordinates);
            }
          } catch (error) {
            console.error('Error handling mouseup:', error);
          }
        });
      } catch (error) {
        console.error('Error creating polygon:', error);
      }
    }

    // Cleanup function
    return () => {
      if (pathChangeListenerRef.current) {
        window.google.maps.event.removeListener(pathChangeListenerRef.current);
        pathChangeListenerRef.current = null;
      }
      if (polygonRef.current) {
        polygonRef.current.setMap(null);
        polygonRef.current = null;
      }
    };
  }, [mapInstance, polygonPath]);

  const fetchRegions = async () => {
    try {
      setLoading(true);
      const response = await apiService.getRegions();

      if (response.success) {
        setRegions(response.data);
        setError('');
      } else {
        setError(response.message || 'Failed to load regions');
        setRegions([]);
      }
    } catch (err) {
      console.error('Regions error:', err);
      setError('Failed to load regions. Please check your connection and try again.');
      setRegions([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setEditMode(false);
    setSelectedRegion(null);
    setPolygonPath([]);
    setJsonInput('');
    setJsonError('');
    setShowJsonPaste(false);
    setIsDrawing(false);
    setInitialZoomSet(false);
    setOpenDialog(true);
  };

  const handleEdit = (region) => {
    setEditMode(true);
    setSelectedRegion(region);
    setJsonInput('');
    setJsonError('');
    setShowJsonPaste(false);
    setIsDrawing(false);
    setInitialZoomSet(false);

    // Parse boundary polygon if exists
    if (region.boundary_polygon) {
      try {
        const parsedPath = typeof region.boundary_polygon === 'string' 
          ? JSON.parse(region.boundary_polygon) 
          : region.boundary_polygon;
        
        // Validate parsed path
        if (Array.isArray(parsedPath) && parsedPath.length > 2) {
          const validPoints = parsedPath.filter(p => 
            p && typeof p.lat === 'number' && typeof p.lng === 'number'
          );
          if (validPoints.length > 2) {
            setPolygonPath(parsedPath);
            console.log('Loaded polygon for editing:', parsedPath);
          } else {
            setPolygonPath([]);
          }
        } else {
          setPolygonPath([]);
        }
      } catch (e) {
        console.error('Error parsing polygon:', e);
        setPolygonPath([]);
      }
    } else {
      setPolygonPath([]);
    }

    setOpenDialog(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this region?')) {
      return;
    }

    try {
      const response = await apiService.deleteRegion(id);

      if (response.success) {
        alert('Region deleted successfully');
        fetchRegions();
      } else {
        alert(response.message || 'Failed to delete region');
      }
    } catch (err) {
      alert('Failed to delete region');
    }
  };

  const handleJsonPaste = (setFieldValue) => {
    setJsonError('');

    if (!jsonInput.trim()) {
      setJsonError('Please paste the region JSON data');
      return;
    }

    try {
      let parsed = JSON.parse(jsonInput.trim());

      if (Array.isArray(parsed)) {
        if (parsed.length === 0) {
          setJsonError('JSON array is empty. Please paste valid region data.');
          return;
        }
        parsed = parsed[0];
      }

      const coordinates = parsed.coordinates || parsed.boundary_polygon;
      if (!coordinates || !Array.isArray(coordinates) || coordinates.length < 3) {
        setJsonError('Invalid JSON: must contain "coordinates" array with at least 3 points.');
        return;
      }

      for (let i = 0; i < coordinates.length; i++) {
        const point = coordinates[i];
        if (typeof point.lat !== 'number' || typeof point.lng !== 'number') {
          setJsonError(`Invalid coordinate at index ${i}: each point must have numeric "lat" and "lng" fields`);
          return;
        }
      }

      const path = coordinates.map(p => ({ lat: p.lat, lng: p.lng }));
      setPolygonPath(path);
      setInitialZoomSet(false);

      if (parsed.name && setFieldValue) {
        setFieldValue('name', parsed.name);
      }

      if (mapInstance && path.length > 2) {
        try {
          const bounds = new window.google.maps.LatLngBounds();
          path.forEach(point => {
            bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
          });
          mapInstance.fitBounds(bounds, 50);
          setInitialZoomSet(true);
        } catch (error) {
          console.error('Error fitting bounds after JSON paste:', error);
        }
      }

      setJsonInput('');
      setJsonError('');
      setShowJsonPaste(false);
    } catch (e) {
      setJsonError(`Invalid JSON format: ${e.message}`);
    }
  };

  const handleMapClick = (e) => {
    if (!isDrawing) return;

    const lat = e.latLng.lat();
    const lng = e.latLng.lng();
    
    setPolygonPath(prev => [...prev, { lat, lng }]);
  };

  const handleDoubleClick = () => {
    if (isDrawing && polygonPath.length > 2) {
      setIsDrawing(false);
    }
  };

  const toggleDrawing = () => {
    if (!isDrawing) {
      setPolygonPath([]);
      setInitialZoomSet(false);
    }
    setIsDrawing(!isDrawing);
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      // Ensure we have the latest polygon path
      let finalPolygonPath = polygonPath;
      
      // If we have a polygon on the map, get the current path directly
      if (polygonRef.current) {
        try {
          const path = polygonRef.current.getPath();
          const coordinates = [];
          for (let i = 0; i < path.getLength(); i++) {
            const point = path.getAt(i);
            coordinates.push({
              lat: point.lat(),
              lng: point.lng(),
            });
          }
          if (coordinates.length >= 3) {
            finalPolygonPath = coordinates;
            console.log('Got polygon from map:', finalPolygonPath);
          }
        } catch (error) {
          console.error('Error getting polygon from map:', error);
        }
      }

      if (finalPolygonPath.length < 3) {
        alert('Please draw a region boundary on the map. A minimum of 3 points is required.');
        setSubmitting(false);
        return;
      }

      const submitData = {
        ...values,
        boundary_polygon: JSON.stringify(finalPolygonPath),
      };

      console.log('Submitting data:', submitData);

      let response;
      if (editMode) {
        response = await apiService.updateRegion(selectedRegion.id, submitData);
      } else {
        response = await apiService.addRegion(submitData);
      }

      if (response.success) {
        alert(`Region ${editMode ? 'updated' : 'created'} successfully`);
        setOpenDialog(false);
        setPolygonPath([]);
        setIsDrawing(false);
        setInitialZoomSet(false);
        fetchRegions();
      } else {
        alert(response.message || 'Operation failed');
      }
    } catch (err) {
      console.error('Submit error:', err);
      alert('Operation failed');
    } finally {
      setSubmitting(false);
    }
  };

  const validationSchema = Yup.object({
    name: Yup.string().required('Region name is required'),
    state: Yup.string().required('State is required'),
    country: Yup.string().required('Country is required'),
    distance_unit: Yup.string().required('Distance unit is required'),
    status: Yup.string().required('Status is required'),
  });

  const columns = [
    {
      field: 'name',
      headerName: 'Region Name',
      width: 200,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <LocationOn color="primary" />
          <Typography variant="body2" fontWeight={600}>
            {params.row.name}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'state',
      headerName: 'State',
      width: 150,
    },
    {
      field: 'country',
      headerName: 'Country',
      width: 120,
    },
    {
      field: 'distance_unit',
      headerName: 'Distance Unit',
      width: 130,
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 130,
      renderCell: (params) =>
        params.row.status === 'active' ? (
          <Chip label="Active" color="success" size="small" />
        ) : (
          <Chip label="Inactive" color="default" size="small" />
        ),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Box>
          <IconButton size="small" onClick={() => handleEdit(params.row)}>
            <Edit fontSize="small" />
          </IconButton>
          <IconButton size="small" color="error" onClick={() => handleDelete(params.row.id)}>
            <Delete fontSize="small" />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Regions
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Manage service regions with geographic boundaries
          </Typography>
        </Box>
        <Button variant="contained" startIcon={<Add />} onClick={handleAdd}>
          Add Region
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      <Card>
        <CardContent>
          <DataGrid
            rows={regions}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 25, 50]}
            disableSelectionOnClick
            autoHeight
            loading={loading}
            sx={{
              '& .MuiDataGrid-cell:focus': {
                outline: 'none',
              },
            }}
          />
        </CardContent>
      </Card>

      {/* Add/Edit Region Dialog */}
      <Dialog
        open={openDialog}
        onClose={() => {
          if (polygonRef.current) {
            polygonRef.current.setMap(null);
            polygonRef.current = null;
          }
          if (pathChangeListenerRef.current) {
            window.google.maps.event.removeListener(pathChangeListenerRef.current);
            pathChangeListenerRef.current = null;
          }
          setOpenDialog(false);
          setMapInstance(null);
          setIsDrawing(false);
          setInitialZoomSet(false);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{editMode ? 'Edit' : 'Add'} Region</DialogTitle>
        <Formik
          initialValues={{
            name: selectedRegion?.name || '',
            state: selectedRegion?.state || '',
            country: selectedRegion?.country || 'India',
            distance_unit: selectedRegion?.distance_unit || 'km',
            status: selectedRegion?.status || 'active',
            description: selectedRegion?.description || '',
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
            <Form>
              <DialogContent>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      name="name"
                      label="Region Name"
                      value={values.name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name && errors.name}
                      placeholder="e.g., Bangalore Central"
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      name="state"
                      label="State"
                      value={values.state}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.state && Boolean(errors.state)}
                      helperText={touched.state && errors.state}
                      placeholder="e.g., Karnataka"
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      name="country"
                      label="Country"
                      value={values.country}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.country && Boolean(errors.country)}
                      helperText={touched.country && errors.country}
                      placeholder="e.g., India"
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel>Distance Unit</InputLabel>
                      <Select
                        name="distance_unit"
                        value={values.distance_unit}
                        onChange={handleChange}
                        label="Distance Unit"
                        error={touched.distance_unit && Boolean(errors.distance_unit)}
                      >
                        <MenuItem value="km">Kilometer (km)</MenuItem>
                        <MenuItem value="mile">Mile</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth>
                      <InputLabel>Status</InputLabel>
                      <Select
                        name="status"
                        value={values.status}
                        onChange={handleChange}
                        label="Status"
                      >
                        <MenuItem value="active">Active</MenuItem>
                        <MenuItem value="inactive">Inactive</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      name="description"
                      label="Description"
                      multiline
                      rows={2}
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Optional description of the region"
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <Typography variant="subtitle2">
                        Region Boundary <span style={{ color: 'red' }}>*</span>
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<ContentPaste />}
                          onClick={() => {
                            setShowJsonPaste(!showJsonPaste);
                            setJsonError('');
                          }}
                        >
                          {showJsonPaste ? 'Hide JSON' : 'Paste JSON'}
                        </Button>
                        <Button
                          size="small"
                          variant={isDrawing ? 'contained' : 'outlined'}
                          color={isDrawing ? 'error' : 'primary'}
                          onClick={toggleDrawing}
                          disabled={showJsonPaste}
                        >
                          {isDrawing ? 'Stop Drawing' : 'Draw Polygon'}
                        </Button>
                      </Box>
                    </Box>

                    {/* JSON Paste Section */}
                    {showJsonPaste && (
                      <Box sx={{ mb: 2, p: 2, border: '1px solid #1976d2', borderRadius: 1, bgcolor: '#f5f9ff' }}>
                        <Typography variant="body2" fontWeight={600} gutterBottom>
                          Paste Region JSON Data
                        </Typography>
                        <Typography variant="caption" color="text.secondary" component="div" sx={{ mb: 1.5 }}>
                          Supports format:<br/>
                          <code>{`[{ "name": "Region 1", "coordinates": [{ "lat": 12.97, "lng": 77.59 }, ...] }]`}</code>
                        </Typography>
                        <TextField
                          fullWidth
                          multiline
                          rows={5}
                          value={jsonInput}
                          onChange={(e) => {
                            setJsonInput(e.target.value);
                            setJsonError('');
                          }}
                          placeholder={`Paste region JSON here...`}
                          sx={{ mb: 1.5, bgcolor: 'white', fontFamily: 'monospace', fontSize: '0.85rem' }}
                          InputProps={{ style: { fontFamily: 'monospace', fontSize: '0.85rem' } }}
                        />
                        {jsonError && (
                          <Alert severity="error" sx={{ mb: 1.5 }}>
                            {jsonError}
                          </Alert>
                        )}
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <Button
                            variant="contained"
                            size="small"
                            startIcon={<ContentPaste />}
                            onClick={() => handleJsonPaste(setFieldValue)}
                          >
                            Apply JSON
                          </Button>
                          <Button
                            variant="outlined"
                            size="small"
                            startIcon={<Clear />}
                            onClick={() => {
                              setJsonInput('');
                              setJsonError('');
                            }}
                          >
                            Clear
                          </Button>
                        </Box>
                      </Box>
                    )}

                    <Alert severity="info" sx={{ mb: 2 }}>
                      <Typography variant="body2" gutterBottom>
                        <strong>How to set region boundary:</strong>
                      </Typography>
                      <Typography variant="caption" component="div">
                        <strong>Option 1 - Draw:</strong> Click "Draw Polygon", click on the map to add points, double-click to finish<br/>
                        <strong>Option 2 - Paste JSON:</strong> Click "Paste JSON" and paste the coordinates data                        
                      </Typography>
                    </Alert>

                    {loadError && (
                      <Alert severity="error" sx={{ mb: 1 }}>
                        Error loading Google Maps. Please check your API key.
                      </Alert>
                    )}

                    {!isLoaded && !loadError && (
                      <Alert severity="warning" sx={{ mb: 1 }}>
                        Loading Google Maps...
                      </Alert>
                    )}

                    {isLoaded && isDrawing && (
                      <Alert severity="success" sx={{ mb: 1 }}>
                        ✓ Drawing mode active. Click on the map to add points. Double-click to finish.
                      </Alert>
                    )}

                    {isLoaded && (
                      <Box
                        sx={{
                          border: '1px solid #ddd',
                          borderRadius: 1,
                          overflow: 'hidden',
                          position: 'relative'
                        }}
                      >
                        <GoogleMap
                          mapContainerStyle={mapContainerStyle}
                          center={defaultCenter}
                          zoom={12}
                          onLoad={(map) => {
                            setMapInstance(map);
                          }}
                          onClick={handleMapClick}
                          onDblClick={handleDoubleClick}
                          options={{
                            clickableIcons: false,
                            draggableCursor: isDrawing ? 'crosshair' : 'default',
                          }}
                        >
                        </GoogleMap>
                        {isDrawing && (
                          <Box
                            sx={{
                              position: 'absolute',
                              bottom: 16,
                              left: '50%',
                              transform: 'translateX(-50%)',
                              bgcolor: 'rgba(0,0,0,0.7)',
                              color: 'white',
                              px: 2,
                              py: 1,
                              borderRadius: 1,
                              fontSize: '0.875rem',
                              pointerEvents: 'none',
                              zIndex: 1,
                            }}
                          >
                            Click to add points • Double-click to finish
                          </Box>
                        )}
                      </Box>
                    )}

                    {polygonPath.length > 2 && (
                      <Box mt={1} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                        <Chip
                          label={`${polygonPath.length} points drawn`}
                          color="success"
                          size="small"
                          onDelete={() => {
                            setPolygonPath([]);
                            setIsDrawing(false);
                          }}
                        />
                        {isDrawing && (
                          <Chip
                            label="Double-click to finish"
                            color="info"
                            size="small"
                          />
                        )}
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => {
                  setOpenDialog(false);
                  setIsDrawing(false);
                  if (polygonRef.current) {
                    polygonRef.current.setMap(null);
                    polygonRef.current = null;
                  }
                  if (pathChangeListenerRef.current) {
                    window.google.maps.event.removeListener(pathChangeListenerRef.current);
                    pathChangeListenerRef.current = null;
                  }
                }}>
                  Cancel
                </Button>
                <Button type="submit" variant="contained" disabled={isSubmitting}>
                  {editMode ? 'Update' : 'Create'}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </Box>
  );
};

export default RegionsPage;